"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const xIconCloseButton_1 = require("components/xIconCloseButton");
const modalContext_1 = require("./modalContext");
require("@hotmart/cosmos/dist/modal/modal-header");
const ModalHeader = ({ children, className = '', ...rest }) => {
    const { onClose } = (0, modalContext_1.useModalContext)();
    return ((0, jsx_runtime_1.jsx)("hot-modal-header", { class: className, "data-test": "modal-header", ...rest, children: (0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _justify-content-between", children: [(0, jsx_runtime_1.jsx)("div", { className: "_w-full", children: children }), onClose && ((0, jsx_runtime_1.jsx)(xIconCloseButton_1.XIconCloseButton, { iconClassName: "_text-4 _text-gray-400", onClick: onClose }))] }) }));
};
exports.default = ModalHeader;
